<template>
  <div class="app_container">
    <el-tabs v-model="actionType" @tab-click="handleActionTypeClick">
      <el-tab-pane v-for="(item, i) in tabList" :label="item.name" :name="item.value" :key="i" lazy>
        <ConfigContent v-if="actionType === item.value" :showFeature="item.value === '2'" :actionType="actionType" ></ConfigContent>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import ConfigContent from "@/pages/homeConfig/components/configContent.vue";
export default {
  name: "homeConfig",
  components: {
    ConfigContent
  },
  data() {
    return {
      actionType: "2",
      tabList: [
        {name: '小程序', value: '2'},
        {name: 'PC端', value: '3'},
        {name: 'APP', value: '0'},
        {name: 'WEB', value: '1'}
      ]
    };
  },
  created() {
    // 处理 query 
    this.actionType = this.$route.query.actionType || "2";
  },
  mounted() {},
  methods: {
    handleActionTypeClick() {

    },
  }
};
</script>

<style lang="scss" scoped>

</style>
